import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const qaList = [
  {
    q: "一人でも大丈夫ですか？",
    a: "もちろん大丈夫です。カウンター席もございますので、お一人様でも気軽にお越しください。スタッフがお話し相手になります。",
  },
  {
    q: "喫煙できますか？",
    a: "電子タバコのみ店内でご使用いただけます。紙タバコはご遠慮ください。",
  },
  {
    q: "ドレスコードはありますか？",
    a: "ドレスコードは設けておりません。カジュアルな服装でもお気軽にどうぞ。お仕事帰りのスーツ姿も大歓迎です。",
  },
  {
    q: "予約は必要ですか？",
    a: "予約は必須ではありませんが、混雑する時間帯はお待たせする場合がございます。ご予約いただけますとスムーズにご案内できます。",
  },
  {
    q: "飲み放題に含まれるお酒は？",
    a: "ハイボール、サワー、カクテル（基本）、ソフトドリンクなどがございます。詳細はスタッフまでお気軽にご相談ください。",
  },
  {
    q: "支払い方法は何が使えますか？",
    a: "現金のほか、クレジットカード（Visa/Master/JCB等）、電子マネー、QRコード決済にも対応しております。",
  },
];

export default function QASection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="qa" className="relative w-full py-20 md:py-32 bg-warm-950">
      <div className="max-w-[1000px] mx-auto px-6">
        <div>
          {/* Q&A */}
          <div className="w-full">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="mb-8 md:mb-10"
            >
              <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-sans font-medium tracking-super-wide text-warm-400 bg-warm-800 border border-warm-700 rounded-full mb-4">
                Q&A
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-warm-100">
                よくある質問
              </h2>
              <p className="mt-3 text-sm font-sans text-warm-400">
                初めての方が気になることをまとめました
              </p>
            </motion.div>

            <div className="space-y-3">
              {qaList.map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.4, delay: i * 0.05 }}
                >
                  <button
                    onClick={() => toggle(i)}
                    className="w-full text-left cursor-pointer"
                  >
                    <div
                      className={`rounded-xl p-4 md:p-5 transition-all duration-300 ${
                        openIndex === i
                          ? "bg-warm-900 border border-amber-500/20"
                          : "bg-warm-900/60 hover:bg-warm-900 border border-transparent"
                      }`}
                    >
                      <div className="flex items-start gap-3 md:gap-4">
                        <span className="flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full bg-amber-500/15 flex items-center justify-center text-xs font-sans font-bold text-amber-500 mt-0.5">
                          Q
                        </span>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm md:text-base font-sans font-medium text-warm-100 leading-relaxed">
                            {item.q}
                          </p>
                          <AnimatePresence>
                            {openIndex === i && (
                              <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                className="overflow-hidden"
                              >
                                <div className="pt-3 mt-3 border-t border-warm-800 flex gap-3 md:gap-4">
                                  <span className="flex-shrink-0 w-6 h-6 md:w-7 md:h-7 rounded-full bg-warm-800 flex items-center justify-center text-xs font-sans font-bold text-warm-400 mt-0.5">
                                    A
                                  </span>
                                  <p className="text-sm font-sans text-warm-300 leading-relaxed">
                                    {item.a}
                                  </p>
                                </div>
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </div>
                        <i
                          className={`ri-arrow-down-s-line text-xl text-warm-500 flex-shrink-0 transition-transform duration-300 ${
                            openIndex === i ? "rotate-180" : ""
                          }`}
                        />
                      </div>
                    </div>
                  </button>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}